import { bool, string } from "prop-types";
import { observer } from "mobx-react";
import { Totals } from "@repo/utils";
import { useEstimateStructure } from "@tools";
import { TotalCost, TotalHours, TotalTime } from "../totalsTypes";

export const TotalsFactory = observer(({
  name,
  ...props
}) => {
  const structure = useEstimateStructure();
  const { hideAllPrices } = structure;
  const {
    apply,
    hideTotalHours,
    hideTotalCost,
    hideTotalTime,
  } = structure.visibility;
  
  switch (name) {
    case Totals.COST:
      return (apply && hideTotalCost) || hideAllPrices
        ? <></>
        : <TotalCost { ...props } />;
      
    case Totals.HOURS:
      return apply && hideTotalHours
        ? <></>
        : <TotalHours { ...props } />;
      
    case Totals.TIME:
      return apply && hideTotalTime
        ? <></>
        : <TotalTime { ...props } />;
  }
});

TotalsFactory.propTypes = {
  name: string.isRequired,
  compact: bool,
}